module.exports = __webpack_public_path__ + "static/ochs-0db29237bac375f05363820878eead31.jpeg";